export default "__VITE_ASSET__BXYYIDeY__"